module.exports = __webpack_public_path__ + "img/example_img.c824338c.png";